import { BsDownload, BsTruck, BsFileText, BsArrowRight } from "react-icons/bs";
import { useState } from "react";
import { Link } from 'react-router-dom';

const OpenAccountSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const cards = [
    {
      id: 1,
      title: "Download A/C Opening Form",
      text: "Download the account opening form for the equities & currency. Send to our Delhi office.",
      buttonText: "Please Download",
      animation: "fade-up",
      icon: <BsDownload className="card-icon" />,
      color: "#007bff",
      gradient: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
      action: "openPdf" // Opens PDF in new tab
    },
    {
      id: 2,
      title: "Query From",
      text: "Just click on the button below to receive a/c opening form in hard copy at no extra cost",
      buttonText: "Click Now",
      animation: "fade-up",
      icon: <BsTruck className="card-icon" />,
      color: "#28a745",
      gradient: "linear-gradient(135deg, #28a745 0%, #1e7e34 100%)",
      action: "openModal" // Opens modal
    },
    {
      id: 3,
      title: "Assisted Account Opening",
      text: "Click below to download the excel sheet. Fill the excel with your details and send to info@asiaticstock.in. We shall fill the account opening form for you and send it to your address for your signatures.",
      buttonText: "Please Download",
      animation: "fade-up",
      icon: <BsFileText className="card-icon" />,
      color: "#ff6b6b",
      gradient: "linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)",
      action: "downloadPdf" // Downloads PDF directly
    },
  ];

  // Function to handle button clicks
  const handleButtonClick = (action) => {
    switch (action) {
      case "openPdf":
        openPdfInNewTab();
        break;
      case "openModal":
        setIsModalOpen(true);
        break;
      case "downloadPdf":
        downloadPdf();
        break;
      default:
        break;
    }
  };

  // Function to open PDF in new tab
  const openPdfInNewTab = () => {
    // Replace with your actual PDF URL
    const pdfUrl = "assets/pdf/KYC FORM.pdf";
    window.open(pdfUrl, '_blank');
  };

  // Function to download PDF
  const downloadPdf = () => {
    // Replace with your actual PDF URL path
    const pdfUrl = "/assets/pdf/KYC-EXCEL-sheet.xls";
    
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'KYC-EXCEL-sheet.xls'; // Only the filename, not the path
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to handle courier request submission
  const handleCourierRequest = (e) => {
    e.preventDefault();
    // Add your form submission logic here
    alert("Courier request submitted successfully!");
    setIsModalOpen(false);
  };

  return (
    <section className="py-16">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="fw-bold mt-5 mb-2">Open New Account</h2>
        </div>

        {/* Enhanced Three Cards Section */}
        <div className="cards-grid">
          {cards.map((card) => (
            <div className="card-item" key={card.id}>
              <div
                className="card-inner"
                data-aos={card.animation}
                data-aos-duration="1000"
              >
                {/* Icon Container */}
                <div 
                  className="icon-container"
                  style={{ background: card.gradient }}
                >
                  {card.icon}
                </div>

                {/* Content */}
                <div className="card-content">
                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-text">{card.text}</p>
                  
                  <button
                    className="card-button"
                    style={{ 
                      background: card.gradient,
                      '--hover-color': card.color 
                    }}
                    onClick={() => handleButtonClick(card.action)}
                  >
                    {card.buttonText}
                    <BsArrowRight className="button-icon" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Enhanced Courier Request Modal */}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              {/* Modal Header with Gradient */}
              <div className="modal-header">
                <div className="modal-header-content">
                  <div className="modal-icon">
                    <BsTruck />
                  </div>
                  <div className="modal-title-section">
                    <h3 className="modal-title">Query From</h3>
                  </div>
                </div>
                <button 
                  className="modal-close"
                  onClick={() => setIsModalOpen(false)}
                >
                  ×
                </button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form onSubmit={handleCourierRequest}>
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Full Name <span className="required">*</span>
                      </label>
                      <input 
                        type="text" 
                        id="name" 
                        className="form-input"
                        placeholder="Enter your full name"
                        required 
                      />
                     
                    </div>

                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email Address <span className="required">*</span>
                      </label>
                      <input 
                        type="email" 
                        id="email" 
                        className="form-input"
                        placeholder="Enter your email address"
                        required 
                      />
                    
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone" className="form-label">
                        Phone Number <span className="required">*</span>
                      </label>
                      <input 
                        type="tel" 
                        id="phone" 
                        className="form-input"
                        placeholder="Enter your phone number"
                        required 
                      />
                    
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="address" className="form-label">
                        Complete Address <span className="required">*</span>
                      </label>
                      <textarea 
                        id="address" 
                        className="form-textarea"
                        placeholder="Enter your complete mailing address including street, city, state, and PIN code"
                        rows="4"
                        required 
                      />
                     
                    </div>
                  </div>


                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button 
                      type="button" 
                      className="btn-secondary"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button 
                      type="submit" 
                      className="btn-primary"
                    >
                      <BsTruck className="btn-icon" />
                      Request Form Delivery
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Additional Sections */}
        <div className="mt-5">
          <div className="row text-center">
            <div className="col-md-6 col-lg-4 mb-3">
              <h3 className="trk-btn trk-btn--border trk-btn--primary w-100">
                <Link to="/documentationProcessSimplified">Documentation & Process simplified</Link>
              </h3>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <h3 className="trk-btn trk-btn--border trk-btn--primary w-100">
                <Link to="/faq">FAQ</Link></h3>    
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <h3 className="trk-btn trk-btn--border trk-btn--primary w-100">
                <Link to="/nri-foreign-nationals">NRI / Foreign Nationals</Link></h3>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto 3rem;
        }

        .card-item {
          perspective: 1000px;
        }

        .card-inner {
          background: white;
          border-radius: 20px;
          padding: 2.5rem 2rem;
          text-align: center;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          border: 1px solid rgba(255, 255, 255, 0.2);
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        .card-inner::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--card-gradient, linear-gradient(135deg, #007bff 0%, #0056b3 100%));
          transition: height 0.3s ease;
        }

        .card-inner:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .card-inner:hover::before {
          height: 6px;
        }

        .icon-container {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
          color: white;
          transition: all 0.3s ease;
          position: relative;
          z-index: 2;
        }

        .card-inner:hover .icon-container {
          transform: scale(1.1) rotate(5deg);
        }

        .card-icon {
          font-size: 2rem;
          transition: transform 0.3s ease;
        }

        .card-inner:hover .card-icon {
          transform: scale(1.1);
        }

        .card-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          width: 100%;
          position: relative;
          z-index: 2;
        }

        .card-title {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #2c3e50;
          line-height: 1.3;
          transition: color 0.3s ease;
        }

        .card-inner:hover .card-title {
          color: #1a2530;
        }

        .card-text {
          color: #6c757d;
          line-height: 1.6;
          margin-bottom: 2rem;
          flex: 1;
          transition: color 0.3s ease;
        }

        .card-inner:hover .card-text {
          color: #5a6268;
        }

        .card-button {
          background: linear-gradient(135deg, var(--color, #007bff) 0%, var(--hover-color, #0056b3) 100%);
          color: white;
          border: none;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: auto;
          position: relative;
          overflow: hidden;
        }

        .card-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.5s ease;
        }

        .card-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
        }

        .card-button:hover::before {
          left: 100%;
        }

        .button-icon {
          transition: transform 0.3s ease;
        }

        .card-button:hover .button-icon {
          transform: translateX(4px);
        }

        /* Enhanced Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          padding: 20px;
          backdrop-filter: blur(10px);
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-content {
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          border-radius: 20px;
          max-width: 700px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 
            0 25px 50px rgba(0, 0, 0, 0.25),
            0 0 0 1px rgba(255, 255, 255, 0.1);
          animation: modalSlideIn 0.4s ease-out;
          position: relative;
        }

        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-50px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .modal-content::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #28a745, #20c997, #28a745);
          background-size: 200% 100%;
          animation: shimmer 3s ease-in-out infinite;
          border-radius: 20px 20px 0 0;
        }

        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        .modal-header {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          color: white;
          padding: 0.7rem 2rem;
          border-radius: 20px 20px 0 0;
          position: relative;
        }

        .modal-header-content {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
        }

        .modal-icon {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .modal-title-section {
          flex: 1;
        }

        .modal-title {
          font-size: 1.3rem;
          font-weight: 700;
          margin: 0;
          color: white;
        }

        .modal-subtitle {
          font-size: 0.95rem;
          opacity: 0.9;
          margin: 0;
          line-height: 1.4;
        }

        .modal-close {
          position: absolute;
          // top: 1.5rem;
          right: 1.5rem;
          background: rgba(255, 255, 255, 0.2);
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }

        .modal-close:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: rotate(90deg);
        }

        .modal-body {
          padding: 1rem 2rem 1rem;
        }

        .form-grid {
          display: grid;
          // grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .form-group {
          position: relative;
        }

        .form-group.full-width {
          grid-column: 1 / -1;
        }

        .form-label {
          display: block;
          margin-bottom: 0.3rem;
          font-weight: 600;
          color: #2c3e50;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .required {
          color: #e74c3c;
        }

        .form-input,
        .form-textarea {
          width: 100%;
          padding: 8px 15px;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: #ffffff;
          font-family: inherit;
        }

        .form-textarea {
          padding-left: 45px;
          resize: vertical;
          min-height: 100px;
        }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #28a745;
          box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
          transform: translateY(-2px);
        }

        .input-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 1.1rem;
          pointer-events: none;
          transition: all 0.3s ease;
        }

        .textarea-icon {
          top: 25px;
          transform: none;
        }

        .form-input:focus + .input-icon,
        .form-textarea:focus + .textarea-icon {
          transform: translateY(-50%) scale(1.1);
          color: #28a745;
        }

        .additional-info {
          background: linear-gradient(135deg, #e8f5e8 0%, #f0f9f0 100%);
          border: 1px solid #d4edda;
          border-radius: 12px;
          padding: 1rem 1rem 1rem 3.5rem;
          margin-bottom: 2rem;
          position: relative;
        }

        .info-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          font-size: 1.2rem;
        }

        .info-text {
          font-size: 0.9rem;
          color: #155724;
          line-height: 1.4;
        }

        .modal-actions {
          display: flex;
          gap: 1rem;
          justify-content: flex-end;
          align-items: center;
        }

        .btn-primary {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          color: white;
          border: none;
          padding: 10px 28px;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 1rem;
          box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
        }

        .btn-secondary {
          background: #6c757d;
          color: white;
          border: none;
          padding: 10px 28px;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 1rem;
        }

        .btn-secondary:hover {
          background: #5a6268;
          transform: translateY(-2px);
        }

        .btn-icon {
          font-size: 1.1rem;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .cards-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
            padding: 0 1rem;
          }
          
          .card-inner {
            padding: 2rem 1.5rem;
          }
          
          .icon-container {
            width: 70px;
            height: 70px;
          }
          
          .card-icon {
            font-size: 1.8rem;
          }

          .modal-content {
            margin: 10px;
          }

          .modal-header {
            padding: 1rem 1.5rem 1rem;
          }

          .modal-body {
            padding: 1.5rem 1.5rem 1.5rem;
          }

          .form-grid {
            grid-template-columns: 1fr;
            gap: 0.5rem;
          }

          .modal-actions {
            flex-direction: column-reverse;
          }

          .btn-primary,
          .btn-secondary {
            width: 100%;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .card-inner {
            padding: 1.5rem 1rem;
          }
          
          .card-title {
            font-size: 1.2rem;
          }

          .modal-header-content {
            flex-direction: column;
            text-align: center;
            gap: 0.5rem;
          }

          .modal-icon {
            align-self: center;
          }

          .modal-title {
            font-size: 1.3rem;
          }

          .modal-subtitle {
            font-size: 0.9rem;
          }

          .form-input,
          .form-textarea {
            padding: 12px 12px 12px 40px;
          }
        }
      `}</style>
    </section>
  );
};

export default OpenAccountSection;